import { theme } from '@bvi/mui-theme';

export const styles = {
  wrapper: {
    paddingLeft: 3,
    paddingRight: 3,
    paddingTop: 1,
    paddingBottom: 5,
  },
  subtitle: {
    color: theme.palette.grey[300],
  },
  promotedDateRange: {
    backgroundColor: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.grey[100]}`,
    borderRadius: 1,
    marginBottom: 3,
    marginTop: 2,
    padding: '16px 10px',
    '& h4': {
      color: theme.palette.primary.main,
      marginTop: 0,
    },
  },
  dateRangeFields: {
    flexWrap: 'nowrap',
    '& .MuiFilledInput-input': {
      paddingRight: 0,
    },
    '& .MuiIconButton-root': {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  levelCheckbox: {
    marginRight: '8px',
  },
  submit: {
    marginTop: 2,
  },
};
